import React from "react";
import Typography from "@/foundation/Typography/V2";
import MiddleSection from "./MiddleSection";
import PinkBox from "./PinkBox";

import { Wrapper, LeftSection } from "./style";
import { FlexDiv } from "../../../components/Atoms";

function LeftSideView() {
  return (
    <Wrapper>
      <LeftSection>
        <PinkBox />
        <MiddleSection />
        <FlexDiv
          flexDirection="column"
          justifyContent="space-between"
          style={{ gap: "16px" }}
        >
          <Typography
            variant="label1"
            fontSize="14px"
            lineHeight="24px"
            fontFamily="var(--mori)"
            fontWeight="400"
            textAlign={["center", "left", "left"]}
            style={{
              color: "#293056",
              fontWeight: 400,
            }}
          >
            Our goal is to establish this newsletter as the go-to source for
            trustworthy and credible health-related information.
          </Typography>

          <Typography
            variant="heading3"
            color="#282828"
            fontSize="40px"
            lineHeight="44px"
            fontFamily="var(--forum)"
            textAlign={["center", "left", "left"]}
          >
            Let's get started?
          </Typography>
        </FlexDiv>
      </LeftSection>
    </Wrapper>
  );
}

export default LeftSideView;
